module.exports = __webpack_public_path__ + "static/media/onnx.893ea90b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backends/onnx.svg
// module id = 321
// module chunks = 0